/* istanbul ignore file */
/* eslint-disable react/display-name */
import React from "react";
import { Rapport } from "../../.generated/rapportage/rapportagetypes";
import { Voorblad } from "../hoofdstukonderdelen/voorblad/voorblad";
import { Inleiding } from "../hoofdstukonderdelen/inleiding/inleiding";
import { InhoudsopgaveChapter } from "../hoofdstukonderdelen/inhoudsopgave/inhoudsopgave";
import { HypotheekChapter } from "../hoofdstukonderdelen/hoofdstukken/hypotheek/hypotheek-chapter";
import { AkkoordverklaringChapter } from "../hoofdstukonderdelen/hoofdstukken/akkoordverklaring/akkoordverklaring-chapter";
import { ToelichtingHypotheekvormen } from "../hoofdstukonderdelen/toelichting-hypotheekvormen/toelichting-hypotheekvormen";
import { NieuweLastenChapter } from "../hoofdstukonderdelen/hoofdstukken/nieuwelasten/nieuwe-lasten-chapter";
import WensenEnDoelstellingenChapter from "../hoofdstukonderdelen/hoofdstukken/WensenEnDoelstellingen/wensen-en-doelstellingen-chapter";
import { DisclaimerChapter } from "../hoofdstukonderdelen/hoofdstukken/disclaimer/disclaimer-chapter";
import { ToelichtingSocialeVoorzieningenChapter } from "../hoofdstukonderdelen/hoofdstukken/socialevoorzieningen/socialevoorzieningen-chapter";
import { KredietenChapter } from "../hoofdstukonderdelen/hoofdstukken/kredieten/kredieten-chapter";
import { LijfrentesChapter } from "../hoofdstukonderdelen/hoofdstukken/lijfrentes/lijfrentes-chapter";
import OnsAdviesChapter from "../hoofdstukonderdelen/hoofdstukken/onsadvies/onsadvies-chapter";
import GeadviseerdeProductenChapter from "../hoofdstukonderdelen/hoofdstukken/geadviseerde-producten/geadviseerde-producten-chapter";
import Bijlagen from "../hoofdstukonderdelen/bijlagen/bijlage";
import { ToelichtingAdviesAlgemeenChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/algemeen/toelichting-advies-algemeen-chapter";
import { ToelichtingInbrengEigenGeldChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/uw-hypotheek/toelichting-advies-inbreng-eigen-geld/toelichting-advies-inbreng-eigen-geld";

import SpaarrekeningenBeleggingsdepotChapter from "../hoofdstukonderdelen/hoofdstukken/geadviseerde-producten/spaarrekeningen-beleggingsdepot-chapter";
import UwBenodigdeFinancieringChapter from "../hoofdstukonderdelen/hoofdstukken/uw-benodigde-financiering/uw-benodigde-financiering-chapter";
import { LastenVergelekenChapter } from "../hoofdstukonderdelen/hoofdstukken/vergeleken-lasten/vergeleken-lasten-chapter";
import DefaultHoofdstukChapter from "../hoofdstukonderdelen/hoofdstukken/default-hoofdstuk";
import { PageBreak } from "../hoofdstukonderdelen/components/PageBreak";
import { FiscaleAftrekChapter } from "../hoofdstukonderdelen/hoofdstukken/uw-benodigde-financiering/fiscale-aftrek/fiscale-aftrek-chapter";
import ArbeidsongeschiktheidsverzekeringChapter from "../hoofdstukonderdelen/hoofdstukken/geadviseerde-producten/arbeidsongeschiktheidverzekeringen-chapter";
import { ToelichtingAdviesVerantwoordeWoonlastenChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/uw-hypotheek/toelichting-advies-hypotheek-verantwoorde-woonlasten/toelichting-advies-hypotheek-verantwoorde-woonlasten";
import OverlijdensrisicoverzekeringChapter from "../hoofdstukonderdelen/hoofdstukken/geadviseerde-producten/overlijdensrisicoverzekeringen-chapter";
import ToelichtingRisicoscenariosChapter from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/algemeen/toelichting-risicoscenarios-chapter";
import { LevensverzekeringChapter } from "../hoofdstukonderdelen/hoofdstukken/geadviseerde-producten/levensverzekering/levensverzekering-chapter";
import { OverigeFinancielePostenChapter } from "../hoofdstukonderdelen/hoofdstukken/geadviseerde-producten/overige-financiele-posten/overige-financiele-posten-chapter";
import RentevastperiodeChapter from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/uw-hypotheek/toelichting-advies-hypotheek-rentevastperiode/toelichting-advies-hypotheek-rentevastperiode";
import { ToelichtingAdviesFiscaleAftrekChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/uw-hypotheek/toelichting-advies-hypotheek-fiscale-aftrek/toelichting-advies-hypotheek-fiscale-aftrek";
import { ToelichtingAdviesGeldverstrekkerChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/uw-hypotheek/toelichting-advies-hypotheek-geldverstrekker/toelichting-advies-hypotheek-geldverstrekker";
import { ToelichtingAdviesDubbeleWoonlastenChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/uw-hypotheek/toelichting-advies-hypotheek-dubbele-woonlasten/toelichting-advies-hypotheek-dubbele-woonlasten";
import { ToelichtingAdviesAflossingsvormChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/uw-hypotheek/toelichting-advies-hypotheek-aflossingsvorm/toelichting-advies-hypotheek-aflossingsvorm";
import { ToelichtingAdviesVerduurzamingChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/uw-hypotheek/toelichting-advies-hypotheek-verduurzaming/toelichting-advies-hypotheek-verduurzaming";
import { ToelichtingArbeidsongeschiktheidChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/arbeidsongeschiktheid/toelichting-arbeidsongeschiktheid";
import { ToelichtingWerkloosheidChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/werkloosheid/toelichting-werkloosheid-chapter";
import { ToelichtingOverlijdenChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/overlijden/toelichting-overlijden-chapter";
import { ToelichtingPensioenChapter } from "../hoofdstukonderdelen/hoofdstukken/toelichting-advies/pensioen/toelichting-pensioen-chapter";
import UwKlantprofielChapter from "../hoofdstukonderdelen/bijlagen/klantprofiel/bijlage-klantprofiel";
import KlantprofielChapter from "../hoofdstukonderdelen/bijlagen/klantprofiel/KlantprofielChapter";
import BijlageKlantprofielAlgemeenChapter from "../hoofdstukonderdelen/bijlagen/klantprofiel/bijlage-klantprofiel-algemeen";
import { AcceptatieChapter } from "../hoofdstukonderdelen/hoofdstukken/Acceptatie/acceptatie-chapter";
import BelangijkFinancieleGebeurtenissenChapter from "../hoofdstukonderdelen/hoofdstukken/belangrijke-financiele-gebeurtenissen/belangrijke-gebeurtenissen";
import { HuidigeSituatieChapter } from "../hoofdstukonderdelen/hoofdstukken/huidige-situatie/huidige-situatie-chapter";

export type RapportComponentProps = {
  rapport: Rapport;
};

export const rapportComponentMap: Record<
  keyof Rapport | "bijlagen" | "toelichtingAdvies",
  React.FC<RapportComponentProps> | null
> = {
  voorblad: ({ rapport }) =>
    rapport.voorblad ? (
      <Voorblad key="voorblad" voorblad={rapport.voorblad} />
    ) : null,
  inleiding: ({ rapport }) =>
    rapport.inleiding ? <Inleiding inleiding={rapport.inleiding} /> : null,
  inhoudsopgaveTonen: ({ rapport }) => {
    return rapport.inhoudsopgaveTonen ? <InhoudsopgaveChapter /> : null;
  },
  belangrijkeFinancieleGebeurtenissen: ({ rapport }) =>
    rapport.belangrijkeFinancieleGebeurtenissen ? (
      <BelangijkFinancieleGebeurtenissenChapter
        titel={rapport.belangrijkeFinancieleGebeurtenissen.titel}
        gebeurtenissen={
          rapport.belangrijkeFinancieleGebeurtenissen.gebeurtenissen
        }
      />
    ) : null,
  wensenEnDoelstellingenHoofdstuk: ({ rapport }) =>
    rapport.wensenEnDoelstellingenHoofdstuk ? (
      <WensenEnDoelstellingenChapter
        wensenEnDoelstellingen={rapport.wensenEnDoelstellingenHoofdstuk}
        aanleidingen={rapport.aanleidingHoofdstuk}
        dienstverlening={rapport.dienstverleningHoofdstuk}
      />
    ) : null,
  uwBenodigdeFinanciering: ({ rapport }) =>
    rapport.uwBenodigdeFinanciering ? (
      <UwBenodigdeFinancieringChapter
        uwBenodigdeFinanciering={rapport.uwBenodigdeFinanciering}
        financieringsopzet={rapport.financieringsopzet}
        overwaardeSpecificatie={rapport.specificatieOverwaarde}
        verbouwingsSpecificatie={rapport.verbouwingsspecificatie}
      />
    ) : null,
  onsAdvies: ({ rapport }) =>
    rapport.onsAdvies ? (
      <OnsAdviesChapter
        onsAdvies={rapport.onsAdvies}
        geadviseerdeProducten={rapport.geadviseerdeProducten}
      />
    ) : null,
  geadviseerdeProducten: ({ rapport }) =>
    rapport.geadviseerdeProducten ? (
      <GeadviseerdeProductenChapter
        geadviseerdeProducten={rapport.geadviseerdeProducten}
      />
    ) : null,
  hypotheek: ({ rapport }) =>
    rapport.hypotheek ? (
      <HypotheekChapter hypotheek={rapport.hypotheek} />
    ) : null,
  levensverzekering: ({ rapport }) =>
    rapport.levensverzekering ? (
      <LevensverzekeringChapter hoofdstuk={rapport.levensverzekering} />
    ) : null,
  overigeFinancielePosten: ({ rapport }) =>
    rapport.overigeFinancielePosten ? (
      <OverigeFinancielePostenChapter
        hoofdstuk={rapport.overigeFinancielePosten}
      />
    ) : null,
  toelichtingHypotheekvormen: ({ rapport }) =>
    rapport.toelichtingHypotheekvormen ? (
      <ToelichtingHypotheekvormen
        toelichtingHypotheekvormen={rapport.toelichtingHypotheekvormen}
      />
    ) : null,
  nieuweLastenOverzicht: ({ rapport }) =>
    rapport.nieuweLastenOverzicht ? (
      <NieuweLastenChapter nieuweLasten={rapport.nieuweLastenOverzicht} />
    ) : null,
  akkoordverklaring: ({ rapport }) =>
    rapport.akkoordverklaring ? (
      <AkkoordverklaringChapter akkoordverklaring={rapport.akkoordverklaring} />
    ) : null,
  disclaimer: ({ rapport }) =>
    rapport.disclaimer ? (
      <DisclaimerChapter disclaimer={rapport.disclaimer} />
    ) : null,
  financieringsopzet: null,
  specificatieOverwaarde: null,
  verbouwingsspecificatie: null,
  toelichtingSocialeVoorzieningen: ({ rapport }) =>
    rapport.toelichtingSocialeVoorzieningen ? (
      <ToelichtingSocialeVoorzieningenChapter
        toelichtingSocialeVoorzieningen={
          rapport.toelichtingSocialeVoorzieningen
        }
      />
    ) : null,
  kredietenHoofdstuk: ({ rapport }) =>
    rapport.kredietenHoofdstuk ? (
      <KredietenChapter kredietenHoofdstuk={rapport.kredietenHoofdstuk} />
    ) : null,
  lijfrentes: ({ rapport }) =>
    rapport.lijfrentes ? (
      <LijfrentesChapter lijfrentesHoofdstuk={rapport.lijfrentes} />
    ) : null,
  toelichtingAdvies: ({ rapport }) =>
    rapport.toelichtingAdvies ? (
      <DefaultHoofdstukChapter
        titel={rapport.toelichtingAdvies.titel}
        level={1}
      />
    ) : null,
  toelichtingAdviesAlgemeenHoofdstuk: ({ rapport }) =>
    rapport.toelichtingAdviesAlgemeenHoofdstuk ? (
      <ToelichtingAdviesAlgemeenChapter
        hoofdstuk={rapport.toelichtingAdviesAlgemeenHoofdstuk}
      />
    ) : null,
  toelichtingUwHypotheek: ({ rapport }) =>
    rapport.toelichtingVerantwoordeWoonlastenHoofdstuk ||
    rapport.toelichtingVerduurzamingHoofdstuk ? (
      <>
        <PageBreak />
        <DefaultHoofdstukChapter
          defaultHoofdstuk={rapport.toelichtingUwHypotheek ?? undefined}
          titel="Uw hypotheek"
        />
      </>
    ) : null,
  toelichtingVerduurzamingHoofdstuk: ({ rapport }) =>
    rapport.toelichtingVerduurzamingHoofdstuk ? (
      <ToelichtingAdviesVerduurzamingChapter
        hoofdstuk={rapport.toelichtingVerduurzamingHoofdstuk}
      />
    ) : null,
  toelichtingVerantwoordeWoonlastenHoofdstuk: ({ rapport }) =>
    rapport.toelichtingVerantwoordeWoonlastenHoofdstuk ? (
      <ToelichtingAdviesVerantwoordeWoonlastenChapter
        hoofdstuk={rapport.toelichtingVerantwoordeWoonlastenHoofdstuk}
      />
    ) : null,
  toelichtingHypotheekGeldverstrekker: ({ rapport }) =>
    rapport.toelichtingHypotheekGeldverstrekker ? (
      <ToelichtingAdviesGeldverstrekkerChapter
        hoofdstuk={rapport.toelichtingHypotheekGeldverstrekker}
      />
    ) : null,
  toelichtingRisicoscenarios: ({ rapport }) =>
    rapport.toelichtingRisicoscenarios ? (
      <ToelichtingRisicoscenariosChapter
        hoofdstuk={rapport.toelichtingRisicoscenarios}
      />
    ) : null,
  klantprofielHypotheekAlgemeen: ({ rapport }) =>
    rapport.klantprofielHypotheekAlgemeen ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielHypotheekAlgemeen.titel || "Hypotheek - Algemeen"
        }
        questions={
          rapport.klantprofielHypotheekAlgemeen.hypotheekAlgemeen || []
        }
        reverseOrder
      />
    ) : null,
  klantProfiel: ({ rapport }) =>
    Object.entries(rapport).some(
      ([key, value]) =>
        key.startsWith("klantprofiel") && value !== null && value !== undefined
    ) ? (
      <UwKlantprofielChapter
        uwKlantprofielHoofdstuk={rapport.klantProfiel!}
        klantprofielAlgemeenHoofdstuk={rapport.klantProfielAlgemeen!}
      />
    ) : null,
  klantProfielAlgemeen: ({ rapport }) =>
    rapport.klantProfielAlgemeen ? (
      <BijlageKlantprofielAlgemeenChapter
        hoofdstuk={rapport.klantProfielAlgemeen}
      />
    ) : null,
  bijlagen: () => <Bijlagen />,
  rapportId: null,
  rapportNaam: null,
  rapportLogo: null,
  huidigeSituatie: ({ rapport }) =>
    rapport.huidigeSituatie ? (
      <HuidigeSituatieChapter hoofdstuk={rapport.huidigeSituatie} />
    ) : null,
  aanleidingHoofdstuk: null,
  dienstverleningHoofdstuk: null,
  toelichtingHypotheekRentevastperiodeHoofdstuk: ({ rapport }) =>
    rapport.toelichtingHypotheekRentevastperiodeHoofdstuk ? (
      <RentevastperiodeChapter
        hoofdstuk={rapport.toelichtingHypotheekRentevastperiodeHoofdstuk}
      />
    ) : null,
  aovHoofdstuk: ({ rapport }) =>
    rapport.aovHoofdstuk ? (
      <ArbeidsongeschiktheidsverzekeringChapter
        hoofdstuk={rapport.aovHoofdstuk}
      />
    ) : null,
  overlijdensrisicoverzekering: ({ rapport }) =>
    rapport.overlijdensrisicoverzekering ? (
      <OverlijdensrisicoverzekeringChapter
        hoofdstuk={rapport.overlijdensrisicoverzekering}
      />
    ) : null,
  fiscaleAftrek: ({ rapport }) =>
    rapport.fiscaleAftrek ? (
      <FiscaleAftrekChapter fiscaleAftrek={rapport.fiscaleAftrek} />
    ) : null,
  spaarrekeningenHoofdstuk: ({ rapport }) =>
    rapport.spaarrekeningenHoofdstuk ? (
      <SpaarrekeningenBeleggingsdepotChapter
        hoofdstuk={rapport.spaarrekeningenHoofdstuk}
      />
    ) : null,
  toelichtingHypotheekvormHoofdstuk: ({ rapport }) =>
    rapport.toelichtingHypotheekvormHoofdstuk ? (
      <ToelichtingAdviesAflossingsvormChapter
        hoofdstuk={rapport.toelichtingHypotheekvormHoofdstuk}
      />
    ) : null,

  toelichtingFiscaleAftrekHoofdstuk: ({ rapport }) =>
    rapport.toelichtingFiscaleAftrekHoofdstuk ? (
      <ToelichtingAdviesFiscaleAftrekChapter
        hoofdstuk={rapport.toelichtingFiscaleAftrekHoofdstuk}
      />
    ) : null,
  toelichtingHypotheekDubbeleLasten: ({ rapport }) =>
    rapport.toelichtingHypotheekDubbeleLasten ? (
      <ToelichtingAdviesDubbeleWoonlastenChapter
        hoofdstuk={rapport.toelichtingHypotheekDubbeleLasten}
      />
    ) : null,
  rapportFooter: null,
  lastenVergeleken: ({ rapport }) =>
    rapport.lastenVergeleken ? (
      <LastenVergelekenChapter lastenVergeleken={rapport.lastenVergeleken} />
    ) : null,
  toelichtingArbeidsongeschiktheid: ({ rapport }) =>
    rapport.toelichtingArbeidsongeschiktheid ? (
      <ToelichtingArbeidsongeschiktheidChapter
        hoofdstuk={rapport.toelichtingArbeidsongeschiktheid}
      />
    ) : null,
  toelichtingWerkloosheid: ({ rapport }) =>
    rapport.toelichtingWerkloosheid ? (
      <ToelichtingWerkloosheidChapter
        hoofdstuk={rapport.toelichtingWerkloosheid}
      />
    ) : null,
  toelichtingOverlijden: ({ rapport }) =>
    rapport.toelichtingOverlijden ? (
      <ToelichtingOverlijdenChapter hoofdstuk={rapport.toelichtingOverlijden} />
    ) : null,
  toelichtingPensioen: ({ rapport }) =>
    rapport.toelichtingPensioen ? (
      <ToelichtingPensioenChapter hoofdstuk={rapport.toelichtingPensioen} />
    ) : null,
  toelichtingInbrengEigenGeld: ({ rapport }) =>
    rapport.toelichtingInbrengEigenGeld ? (
      <ToelichtingInbrengEigenGeldChapter
        hoofdstuk={rapport.toelichtingInbrengEigenGeld}
      />
    ) : null,
  klantprofielRisicosPensioen: ({ rapport }) =>
    rapport.klantprofielRisicosPensioen ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielRisicosPensioen.titel || "Risico's - Pensioen"
        }
        questions={rapport.klantprofielRisicosPensioen.risicosPensioen || []}
      />
    ) : null,
  klantprofielRisicosOverlijden: ({ rapport }) =>
    rapport.klantprofielRisicosOverlijden ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielRisicosOverlijden.titel || "Risico's - Overlijden"
        }
        questions={
          rapport.klantprofielRisicosOverlijden.risicosOverlijden || []
        }
      />
    ) : null,
  klantprofielRisicosWerkloosheid: ({ rapport }) =>
    rapport.klantprofielRisicosWerkloosheid ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielRisicosWerkloosheid.titel ||
          "Risico's - Werkloosheid"
        }
        questions={
          rapport.klantprofielRisicosWerkloosheid.risicosWerkloosheid || []
        }
      />
    ) : null,
  klantprofielRisicosArbeidsongeschiktheid: ({ rapport }) =>
    rapport.klantprofielRisicosArbeidsongeschiktheid ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielRisicosArbeidsongeschiktheid.titel ||
          "Risico's - Arbeidsongeschiktheid"
        }
        questions={
          rapport.klantprofielRisicosArbeidsongeschiktheid
            .risicosArbeidsongeschiktheid || []
        }
      />
    ) : null,
  klantprofielVermogenRisicoprofiel: ({ rapport }) =>
    rapport.klantprofielVermogenRisicoprofiel ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielVermogenRisicoprofiel.titel ||
          "Vermogen - Risicoprofiel"
        }
        questions={
          rapport.klantprofielVermogenRisicoprofiel
            .vermogensopbouwRisicoprofiel || []
        }
      />
    ) : null,
  klantprofielVermogenOpbouwDoelvermogen: ({ rapport }) =>
    rapport.klantprofielVermogenOpbouwDoelvermogen ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielVermogenOpbouwDoelvermogen.titel ||
          "Vermogen - Opbouw doelvermogen"
        }
        questions={
          rapport.klantprofielVermogenOpbouwDoelvermogen
            .vermogensopbouwOpbouwDoelvermogen || []
        }
      />
    ) : null,
  klantprofielHypotheekVerduurzaming: ({ rapport }) =>
    rapport.klantprofielHypotheekVerduurzaming ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielHypotheekVerduurzaming.titel ||
          "Hypotheek - Verduurzaming"
        }
        questions={
          rapport.klantprofielHypotheekVerduurzaming.hypotheekVerduurzaming ||
          []
        }
      />
    ) : null,
  klantprofielHypotheekVerantwoordeWoonlasten: ({ rapport }) =>
    rapport.klantprofielHypotheekVerantwoordeWoonlasten ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielHypotheekVerantwoordeWoonlasten.titel ||
          "Hypotheek - Verantwoorde woonlasten"
        }
        questions={
          rapport.klantprofielHypotheekVerantwoordeWoonlasten
            .hypotheekVerantwoordeWoonlasten || []
        }
      />
    ) : null,
  klantprofielHypotheekRentevastperiode: ({ rapport }) =>
    rapport.klantprofielHypotheekRentevastperiode ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielHypotheekRentevastperiode.titel ||
          "Hypotheek - Rentevastperiode"
        }
        questions={
          rapport.klantprofielHypotheekRentevastperiode
            .hypotheekRentevastperiode || []
        }
      />
    ) : null,
  klantprofielHypotheekGeldverstrekker: ({ rapport }) =>
    rapport.klantprofielHypotheekGeldverstrekker ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielHypotheekGeldverstrekker.titel ||
          "Hypotheek - Geldverstrekker"
        }
        questions={
          rapport.klantprofielHypotheekGeldverstrekker
            .hypotheekGeldverstrekker || []
        }
      />
    ) : null,
  klantprofielHypotheekFiscaleAftrek: ({ rapport }) =>
    rapport.klantprofielHypotheekFiscaleAftrek ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielHypotheekFiscaleAftrek.titel ||
          "Hypotheek - Fiscale aftrek"
        }
        questions={
          rapport.klantprofielHypotheekFiscaleAftrek.hypotheekFiscaal || []
        }
      />
    ) : null,
  klantprofielHypotheekEigenGeld: ({ rapport }) =>
    rapport.klantprofielHypotheekEigenGeld ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielHypotheekEigenGeld.titel ||
          "Hypotheek - Eigen geld"
        }
        questions={
          rapport.klantprofielHypotheekEigenGeld.hypotheekEigenGeld || []
        }
      />
    ) : null,
  klantprofielHypotheekDubbeleWoonlasten: ({ rapport }) =>
    rapport.klantprofielHypotheekDubbeleWoonlasten ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielHypotheekDubbeleWoonlasten.titel ||
          "Hypotheek - Dubbele woonlasten"
        }
        questions={
          rapport.klantprofielHypotheekDubbeleWoonlasten
            .hypotheekDubbeleWoonlasten || []
        }
      />
    ) : null,
  klantprofielHypotheekAflossingsvorm: ({ rapport }) =>
    rapport.klantprofielHypotheekAflossingsvorm ? (
      <KlantprofielChapter
        title={
          rapport.klantprofielHypotheekAflossingsvorm.titel ||
          "Hypotheek - Aflossingsvorm"
        }
        questions={
          rapport.klantprofielHypotheekAflossingsvorm.hypotheekHypotheekvorm ||
          []
        }
      />
    ) : null,
  acceptatie: ({ rapport }) =>
    rapport.acceptatie ? (
      <AcceptatieChapter acceptatie={rapport.acceptatie} />
    ) : null,
  rapportStructuurNaam: null,
  naamAanvrager: null,
  naamPartner: null,
};

export const componentOrder: (
  | keyof Rapport
  | "bijlagen"
  | "toelichtingAdvies"
)[] = [
  "voorblad",
  "inhoudsopgaveTonen",
  "inleiding",
  "wensenEnDoelstellingenHoofdstuk",
  "uwBenodigdeFinanciering",
  "financieringsopzet",
  "specificatieOverwaarde",
  "verbouwingsspecificatie",
  "fiscaleAftrek",
  "onsAdvies",
  "belangrijkeFinancieleGebeurtenissen",
  "geadviseerdeProducten",
  "hypotheek",
  "levensverzekering",
  "overlijdensrisicoverzekering",
  "aovHoofdstuk",
  "spaarrekeningenHoofdstuk",
  "kredietenHoofdstuk",
  "lijfrentes",
  "overigeFinancielePosten",
  "nieuweLastenOverzicht",
  "lastenVergeleken",
  "toelichtingAdvies",
  "toelichtingRisicoscenarios",
  "toelichtingUwHypotheek",
  "toelichtingAdviesAlgemeenHoofdstuk",
  "toelichtingVerduurzamingHoofdstuk",
  "toelichtingVerantwoordeWoonlastenHoofdstuk",
  "toelichtingFiscaleAftrekHoofdstuk",
  "toelichtingInbrengEigenGeld",
  "toelichtingHypotheekDubbeleLasten",
  "toelichtingHypotheekvormHoofdstuk",
  "toelichtingHypotheekRentevastperiodeHoofdstuk",
  "toelichtingHypotheekGeldverstrekker",
  "toelichtingOverlijden",
  "toelichtingArbeidsongeschiktheid",
  "toelichtingWerkloosheid",
  "toelichtingPensioen",
  "acceptatie",
  "akkoordverklaring",
  "bijlagen",
  "huidigeSituatie",
  "klantProfiel",
  "klantProfielAlgemeen",
  "klantprofielHypotheekAlgemeen",
  "klantprofielHypotheekVerduurzaming",
  "klantprofielHypotheekVerantwoordeWoonlasten",
  "klantprofielHypotheekEigenGeld",
  "klantprofielHypotheekDubbeleWoonlasten",
  "klantprofielHypotheekFiscaleAftrek",
  "klantprofielHypotheekAflossingsvorm",
  "klantprofielHypotheekRentevastperiode",
  "klantprofielHypotheekGeldverstrekker",
  "klantprofielRisicosOverlijden",
  "klantprofielRisicosArbeidsongeschiktheid",
  "klantprofielRisicosWerkloosheid",
  "klantprofielRisicosPensioen",
  "klantprofielVermogenOpbouwDoelvermogen",
  "klantprofielVermogenRisicoprofiel",
  "toelichtingHypotheekvormen",
  "toelichtingSocialeVoorzieningen",
  "disclaimer",
];
